<template>
  <main id="main">
    <Loading :isProcessing="isProcessing"></Loading>
    <div class="l-contents">
      <h1 class="l-pageTitle"><span class="l-pageLabel">トライアル申込</span>申込内容確認</h1>
      <div class="l-contentsBox">
        <table class="l-form-table">
          <tr>
            <th class="v-middle"><span>申込先</span></th>
            <td class="v-middle">
              <span style="padding-left: 20px;">{{ trialEntry.entryPlanName }}</span>
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>申込日時</span></th>
            <td class="v-middle">
              <span style="padding-left: 20px;">{{ $dayjs(trialEntry.trialEntryDate).format("YYYY/MM/DD HH:mm") }}</span>
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>料金プラン<em class="label-required">必須</em></span></th>
            <td class="v-middle">
              <div class="l-select w-auto">
                <SelectBox v-model="$v.trialEntry.$model.planId"
                  name="trialEntry.planId"
                  :options="planList"
                  needsBlank="false"
                  :selectedValue="this.trialEntry.planId"></SelectBox>
              </div>
              <ValidationErrorMessage v-show="$v.trialEntry.planId.$error" validation="required" />
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>社名<em class="label-required">必須</em></span></th>
            <td class="v-middle">
              <div class="l-inputAccount">
                <TextBox v-model="$v.trialEntry.$model.corpName" name="trialEntry.corpName" :disabled="isFixed"></TextBox>
                <ValidationErrorMessage v-show="$v.trialEntry.corpName.$error" validation="required" />
              </div>
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>担当者名<em class="label-required">必須</em></span></th>
            <td class="v-middle">
              <div class="l-inputAccount">
                <TextBox v-model="$v.trialEntry.$model.responsibleName" name="trialEntry.responsibleName" :disabled="isFixed"></TextBox>
                <ValidationErrorMessage v-show="$v.trialEntry.responsibleName.$error" validation="required" />
              </div>
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>部署名</span></th>
            <td class="v-middle">
              <div class="l-inputAccount">
                <TextBox v-model="$v.trialEntry.$model.deptName" name="trialEntry.deptName"></TextBox>
              </div>
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>メールアドレス<em class="label-required">必須</em></span></th>
            <td class="v-middle">
              <div class="l-inputAccount">
                <TextBox v-model="$v.trialEntry.$model.mailAddress" name="trialEntry.mailAddress" :disabled="isFixed"></TextBox>
                <ValidationErrorMessage v-show="$v.trialEntry.mailAddress.$error && !$v.trialEntry.mailAddress.required" validation="required" />
                <ValidationErrorMessage v-show="$v.trialEntry.mailAddress.$error && !$v.trialEntry.mailAddress.email" validation="email" />
              </div>
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>メールアドレス確認</span></th>
            <td class="v-middle">
              <span style="padding-left: 20px;" v-if="trialEntry.isMailAddressConfirmed">確認済</span>
              <span style="padding-left: 20px;" v-else>未確認</span>
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>郵便番号<em class="label-required">必須</em></span></th>
            <td class="v-middle">
              <div class="l-inputAccount w-vshort">
                <TextBox v-model="$v.trialEntry.$model.postCd" name="trialEntry.postCd"></TextBox>
              </div>
              <ValidationErrorMessage style="padding: 0 20px;" v-show="$v.trialEntry.postCd.$error && !$v.trialEntry.postCd.required" validation="required" />
              <ValidationErrorMessage style="padding: 0 20px;" v-show="$v.trialEntry.postCd.$error && !$v.trialEntry.postCd.numeric" validation="numeric" />
              <ValidationErrorMessage style="padding: 0 20px;" v-show="$v.trialEntry.postCd.$error && !$v.trialEntry.postCd.maxLength" validation="maxLength" valueLength="7" />
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>都道府県<em class="label-required">必須</em></span></th>
            <td class="v-middle">
              <div class="l-select w-auto">
                <SelectBox v-model="$v.trialEntry.$model.prefectureCd"
                  name="form.prefectureCd"
                  :options="prefs"
                  :selectedValue="this.trialEntry.prefectureCd"></SelectBox>
              </div>
              <ValidationErrorMessage style="padding: 0 20px;" v-show="$v.trialEntry.prefectureCd.$error" validation="required" />
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>市区町村・番地<em class="label-required">必須</em></span></th>
            <td class="v-middle">
              <div class="l-inputAccount">
                <TextBox v-model="$v.trialEntry.$model.address2" name="inputForm.address2"></TextBox>
              </div>
              <ValidationErrorMessage style="padding: 0 20px;" v-show="$v.trialEntry.address2.$error && !$v.trialEntry.address2.required" validation="required" />
              <ValidationErrorMessage style="padding: 0 20px;" v-show="$v.trialEntry.address2.$error && !$v.trialEntry.address2.maxLength" validation="maxLength" valueLength="20" />
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>建物名・部屋番号など</span></th>
            <td class="v-middle">
              <div class="l-inputAccount">
                <TextBox v-model="$v.trialEntry.$model.address3" name="trialEntry.address3"></TextBox>
              </div>
              <ValidationErrorMessage style="padding: 0 20px;" v-show="$v.trialEntry.address3.$error && !$v.trialEntry.address3.maxLength" validation="maxLength" valueLength="300" />
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>電話番号<em class="label-required">必須</em></span></th>
            <td class="v-middle">
              <div class="l-inputAccount w-short">
                <TextBox v-model="$v.trialEntry.$model.tel" name="trialEntry.tel" :disabled="isFixed"></TextBox>
                <ValidationErrorMessage v-show="$v.trialEntry.tel.$error" validation="required" />
              </div>
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>電話番号(ご担当者様)</span></th>
            <td class="v-middle">
              <div class="l-inputAccount w-short">
                <TextBox v-model="$v.trialEntry.$model.responsibleTel" name="trialEntry.tel" style="width: 300px;" placeholder="例: 000-0000-0000"></TextBox>
              </div>
              <ValidationErrorMessage style="padding: 0 20px;" v-show="$v.trialEntry.responsibleTel.$error && !$v.trialEntry.responsibleTel.maxLength" validation="maxLength" valueLength="13" />
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>FAX番号</span></th>
            <td class="v-middle">
              <div class="l-inputAccount w-short">
                <TextBox v-model="$v.trialEntry.$model.faxNo" name="trialEntry.faxNo" style="width: 300px;" placeholder="例: 000-0000-0000"></TextBox>
              </div>
              <ValidationErrorMessage style="padding: 0 20px;" v-show="$v.trialEntry.faxNo.$error && !$v.trialEntry.faxNo.maxLength" validation="maxLength" valueLength="13" />
            </td>
          </tr>
          <!-- 利用プラン　-->
          <tr v-if="$v.trialEntry.$model.planId==4">
            <th class="v-middle"><span>利用プラン<em class="label-required">必須</em></span></th>
            <td>
              <ValidationErrorMessage style="padding: 0 20px;" v-show="$v.trialEntry.usagePlanId.$error" validation="required" />
              <div class="l-radio-block">
                <label class="l-radio">
                  <input type="radio" name="trialEntry.usagePlanId" v-model="$v.trialEntry.$model.usagePlanId" value = 0> {{this.usagePlanList[0].label}}
                </label>
              </div>
              <div class="l-radio-block">
                <label class="l-radio">
                  <input type="radio" name="trialEntry.usagePlanId" v-model="$v.trialEntry.$model.usagePlanId" value = 1> {{this.usagePlanList[1].label}}
                </label>
              </div>
              <div class="l-radio-block">
                <label class="l-radio">
                  <input type="radio" name="trialEntry.usagePlanId" v-model="$v.trialEntry.$model.usagePlanId" value = 2> {{this.usagePlanList[2].label}}
                </label>
              </div>
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>ご紹介者様</span></th>
            <td class="v-middle">
              <div class="l-inputAccount">
                <TextBox v-model="$v.trialEntry.$model.introducerHonorificsName" name="form.introducerHonorificsName"></TextBox>
              </div>
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>お問い合わせ・ご質問等</span></th>
            <td class="v-middle">
              <div class="l-inputAccount">
                <TextArea v-model="$v.trialEntry.$model.comment" :disabled="isFixed" class="l-formGroup__textArea" />
              </div>
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>メールアドレス確認</span></th>
            <td class="v-middle">
              <span style="padding-left: 20px;" v-if="trialEntry.isMailAddressConfirmed">確認済</span>
              <span style="padding-left: 20px;" v-else>未確認</span>
            </td>
          </tr>
          <tr v-if="isFixed">
            <th class="v-middle"><span>確定日時</span></th>
            <td class="v-middle">
              <span style="padding-left: 20px;">{{ $dayjs(trialEntry.trialEntryConfirmDate).format("YYYY/MM/DD HH:mm") }}</span>
            </td>
          </tr>
        </table>
        <div v-if="!isFixed" class="l-contentsBox__bottom" style="text-align: center;">
          <div class="btn-basic is-inlne is-primary js-savebtn" @click="save()"><a>保存</a></div>
          <div class="btn-basic is-inlne is-primary js-savebtn" @click="fix()"><a>確定</a></div>
          <div class="btn-basic is-inlne is-primary js-savebtn" @click="resendMailAddressConfirmMail()"><a>メールアドレス確認メール再送</a></div>
        </div>
        <div v-else class="l-contentsBox__bottom" style="text-align: center;">
          <div class="btn-basic is-inlne is-primary js-savebtn" @click="resendInitPasswordSettingMail()"><a>パスワード初期設定メール再送</a></div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Loading from '@/components/parts/common/Loading.vue';
import TextBox from '@/components/parts/form/TextBox.vue';
import TextArea from '@/components/parts/form/TextArea.vue';
import SelectBox from '@/components/parts/form/SelectBox.vue';
import { required, email, maxLength, numeric, requiredIf } from 'vuelidate/lib/validators';
import ValidationErrorMessage from '@/components/parts/form/ValidationErrorMessage.vue';
import constant from '@/const';

export default {
  components: {
    Loading,
    TextBox,
    TextArea,
    SelectBox,
    ValidationErrorMessage,
  },
  data()  {
    return {
      isProcessing: false,
      trialEntry: {
        corpName: '',
        responsibleName: '',
        mailAddress: '',
        tel: '',
        comment: '',
        trialEntryConfirmDate: null,
        isMailAddressConfirmed: false,
        planId: null,
        deptName: '',
        postCd: '',
        prefectureCd: '1',
        address2: '',
        address3: '',
        faxNo: '',
        introducerHonorificsName: '',
      },
      planList: [
        {
          value: null,
          label: '',
          planOptions: [
            {
              planOptionId: null,
              name: ''
            }
          ]
        }
      ],
      usagePlanList: [
        {
          value: null,
          label: '',
        }
      ],
      prefs: constant.PREFS,
    }
  },
  computed: {
    trialEntryId() {
      return this.$store.getters['trialEntry/getTrialEntryId'];
    },
    isFixed() {
      return this.trialEntry.trialEntryConfirmDate
    },
  　isRoumu() {
      return this.trialEntry.planId == 4;
    },
  },
  validations: {
    trialEntry: {
      corpName: { required },
      responsibleName: { required },
      mailAddress: { required, email },
      tel: { required },
      comment: { },
      planId: { required },
      deptName: { },
      responsibleTel: { maxLength: maxLength(13) },
      postCd: { required, maxLength: maxLength(7), numeric },
      prefectureCd: { required },
      address2: { required, maxLength: maxLength(20) },
      address3: { maxLength: maxLength(300) },
      faxNo: { maxLength: maxLength(13) },
      introducerHonorificsName: { },
      usagePlanId: {
        required: requiredIf(function (value) {
          return this.isRoumu && value;
        })
      },
    }
  },
  created: function () {
    this.getTrialEntry(this.trialEntryId);
  },
  methods: {
    async getTrialEntry(trialEntryId) {
      this.isProcessing = true;
      let res = await this.$axios.post('/ld/api/contact/trial_entry/getTrialEntry', {
        trialEntryId: trialEntryId,
      });
      if (res) {
        this.trialEntry = res.data.trialEntry;
        let planList = [];
        res.data.planList.forEach(p => {
          planList.push({
            value: p.planId,
            label: p.name,
            planOptions: p.planOptions
          });
        });
        this.planList = planList;

        let usagePlanList = [];
        res.data.usagePlanList.forEach(u => {
          usagePlanList.push({
            value: u.usagePlanId,
            label: u.name + " 登録可能件数：" + u.maxCount + "件（¥"+u.amount.toLocaleString()+"/月）",
          });
        });
        this.usagePlanList = usagePlanList;
      }
      this.isProcessing = false;
    },
    async save() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.isProcessing = true;

        // 料金プランが労務サプリ以外のときはusagePlanIdをnullで初期化する
        if ( this.trialEntry.planId != 4 ) this.trialEntry.usagePlanId = null;

        let res = await this.$axios.post('/ld/api/contact/trial_entry/save', {
          trialEntry: this.trialEntry,
        });
        if (res.status === 200) {
          this.$toast.info('トライアル申込の保存が完了しました。');
        } else {
          this.$toast.error('登録時にエラーが発生しました。');
        }
        this.isProcessing = false;
      }
    },
    async fix() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        const answer = window.confirm("申込を確定しますか？")
        if (!answer) {
          return;
        }
        this.isProcessing = true;

        // 料金プランが労務サプリ以外のときはusagePlanIdをnullで初期化する
        if ( this.trialEntry.planId != 4 ) this.trialEntry.usagePlanId = null;

        let res = await this.$axios.post('/ld/api/contact/trial_entry/fix', {
          trialEntry: this.trialEntry,
        });
        if (res.status === 200) {
          this.$toast.info('トライアル申込の確定が完了しました。');
          this.$router.push({ name: 'trial-entry-list' });
        } else if (res.status === 400) {
          this.$toast.error(res.data.message);
        } else {
          this.$toast.error('登録時にエラーが発生しました。');
        }
        this.isProcessing = false;
      }
    },
    async resendMailAddressConfirmMail() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.isProcessing = true;
        let res = await this.$axios.post('/ld/api/contact/trial_entry/resendMailAddressConfirmMail', {
          trialEntryId: this.trialEntry.trialEntryId,
          mailAddress: this.trialEntry.mailAddress,
        });
        if (res.status === 200) {
          this.$toast.info('メールアドレス確認メールを再送しました。');
        } else {
          this.$toast.error('登録時にエラーが発生しました。');
        }
        this.isProcessing = false;
      }
    },
    async resendInitPasswordSettingMail() {
      this.isProcessing = true;
      let res = await this.$axios.post('/ld/api/contact/trial_entry/resendInitPasswordSettingMail', {
        trialEntryId: this.trialEntry.trialEntryId,
      });
      if (res.status === 200) {
        this.$toast.info('パスワード初期設定メールを再送しました。');
      } else {
        this.$toast.error('登録時にエラーが発生しました。');
      }
      this.isProcessing = false;
    },
    emitChangePlan: function () {
      let planOptionList = this.planOptionList;
      this.inputForm.corporatePlanOptions = this.inputForm.corporatePlanOptions.filter(planOptionId => {
        return planOptionList.some(planOption => planOption.planOptionId === planOptionId);
      });
      this.setPlanOptionList();
    },

  }
}

</script>